import React from "react";
import { ArrowUpRight } from "lucide-react";
import { PATENT_ENGINES, MAIN_SITE_URL } from "@/constants/engines";

function EngineCard({ engine }) {
  return (
    <a
      href={MAIN_SITE_URL}
      target="_blank"
      rel="noreferrer"
      className="group relative block overflow-hidden border border-[color:var(--iw-border)] bg-white transition-all hover:-translate-y-0.5 hover:border-[color:var(--iw-blue)]/60 hover:shadow-[0_18px_42px_-18px_rgba(17,41,107,0.4)]"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[color:var(--iw-bg)]">
        <img
          src={engine.img}
          alt={`${engine.title} — patent-pending engine`}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
          decoding="async"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#11296B]/45 via-transparent to-transparent" />
        <div className="absolute left-3 top-3 border border-white/40 bg-[color:var(--iw-primary)]/80 px-2 py-1 font-mono text-[9px] uppercase tracking-[0.22em] text-white backdrop-blur">
          Patent · {engine.n}
        </div>
      </div>
      <div className="flex items-center justify-between gap-3 p-4">
        <div className="font-display text-sm font-semibold leading-tight tracking-tight text-[color:var(--iw-primary)] sm:text-base">
          {engine.title}
        </div>
        <ArrowUpRight className="h-4 w-4 flex-shrink-0 text-[color:var(--iw-accent-red)] transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </div>
    </a>
  );
}

export default function EngineGrid() {
  return (
    <div className="mt-20">
      <div className="mb-10 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-end lg:gap-12">
        <div className="lg:col-span-7">
          <div className="iw-overline mb-3">The full tech stack</div>
          <h3 className="font-display text-2xl font-semibold tracking-tight text-[color:var(--iw-primary)] sm:text-3xl lg:text-4xl">
            Seven patent-pending engines.{" "}
            <span className="text-[color:var(--iw-blue)]">All powering one plan.</span>
          </h3>
          <p className="mt-4 max-w-xl text-lg leading-relaxed text-[color:var(--iw-body)]">
            Each engine reads a different layer of your data. Together, they build your plan.
          </p>
        </div>
        <div className="lg:col-span-5 lg:text-right">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noreferrer"
            className="iw-btn-red inline-flex items-center gap-2 px-6 py-3.5 font-mono text-[13px] uppercase tracking-[0.22em]"
          >
            Explore the AI &amp; 7 Engines <ArrowUpRight className="h-4 w-4" />
          </a>
          <div className="mt-3 font-mono text-[12px] uppercase tracking-[0.22em] text-[color:var(--iw-muted-foreground)]">
            integratednycai.com
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-3">
        {PATENT_ENGINES.map((engine) => (
          <EngineCard key={engine.n} engine={engine} />
        ))}
      </div>

      <div className="mt-6 flex items-center justify-center gap-3 border-t border-[color:var(--iw-border)] pt-6 font-mono text-[12px] uppercase tracking-[0.22em] text-[color:var(--iw-muted-foreground)]">
        <span className="iw-pulse-dot block h-1.5 w-1.5 rounded-full bg-[color:var(--iw-accent-red)]" />
        <span>+ The Integrated Matrix Engine · 7 patent-pending technologies in total</span>
      </div>
    </div>
  );
}
